import React from 'react';

export default function Frag(){
    return <></>;
}